import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary, ToastHost, initErrorReporting } from '@drbell/ui';
import { App } from './app.tsx';
import './styles.css';

// Scrubbed reports to this site's own Worker, which forwards them to Sentry
// only when it has a SENTRY_DSN (packages/ui/src/crash.ts).
initErrorReporting('org');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Outermost, so a crash anywhere shows "Something went wrong — reload"
        rather than a blank page. */}
    <ErrorBoundary>
      {/* Outside App so a toast survives anything App re-renders, and so the
          live region exists in the DOM before the first message is added. */}
      <ToastHost>
        <App />
      </ToastHost>
    </ErrorBoundary>
  </StrictMode>,
);
